import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faTimes, faSms } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import "../../styles/Common.css";

const FloatingActionButton = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const supportPhoneNumber = '17866093374';
  const predefinedMessage = encodeURIComponent('Hey Mr. Sea! I’m interested in booking a boat. Can you help me out?.');

  return (
    <div className="help-fab-container">
      {isOpen && (
        <div className="help-fab-menu">
          <a href={`https://wa.me/${supportPhoneNumber}?text=${predefinedMessage}`} target="_blank" rel="noopener noreferrer" className="help-fab-option">
            <FontAwesomeIcon icon={faWhatsapp} className="help-fab-option-icon whatsapp" />
            <span>Write on WhatsApp</span>
          </a>
          <a href={`sms:${supportPhoneNumber}?body=${predefinedMessage}`} className="help-fab-option">
            <FontAwesomeIcon icon={faSms} className="help-fab-option-icon sms" />
            <span>Send Message</span>
          </a>
        </div>
      )}
      <div className="help-fab-wrapper">
        <span className={`help-fab-text ${isOpen ? 'hidden' : ''}`}>Need help?</span>
        <button className={`help-fab-button ${isOpen ? 'open' : ''}`} onClick={toggleMenu} aria-label="Get help">
          <div className="help-fab-icon-wrapper">
            <FontAwesomeIcon icon={faPhone} className="help-fab-icon main-icon" />
            <FontAwesomeIcon icon={faTimes} className="help-fab-icon close-icon" />
          </div>
        </button>
      </div>
    </div>
  );
};

export default FloatingActionButton;
